/********************************************
* Flexible content builders
* builder/article.builder--post
********************************************/
function fnBuilders( i, oSection ) {

	/*****************
	* Objects
	*****************/
	var oSection						= $( oSection ),
		oBlocks							= $( '[data-block]', oSection );

	// Return if no blocks (for old articles that rely on the_content() WYSIWYG)
	if ( oBlocks === 0 ) return;

	/*****************
	* Detect next block and apply class `before--{{ next-block }}` for flexible styling
	*****************/
	oBlocks.each( function() {

		var sCurrentBlockType			= $( this ).attr( 'data-block' ),
			sNextBlockType				= $( this ).next( oBlocks ).attr( 'data-block' );

		if ( sNextBlockType !== undefined ) {
			$( this ).addClass( 'before--' + sNextBlockType );
		}

	} );

	/*****************
	* Specific blocks
	*****************/

	// Add class to first block
	oBlocks.first().addClass( 'first-page-section' );

	// Add class to last block
	oBlocks.last().addClass( 'last-page-section' );

}


// END OF DOCUMENT
